<aside class="sm-nav-bar" role="navigation" [attr.aria-label]="'shell.nav.mainNavigationAriaLabel' | translate">
  <header class="sm-nav-bar__header" *ngIf="profile">
    <div class="sm-nav-bar__profile-avatar" aria-hidden="true">
      <span>{{ profile.avatarText || 'U' }}</span>
    </div>

    <div class="sm-nav-bar__profile-copy">
      <div class="sm-nav-bar__email">{{ profile.email }}</div>
      <div class="sm-nav-bar__role">{{ profile.roleLabel }}</div>
    </div>
  </header>

  <div class="sm-nav-bar__divider" *ngIf="profile"></div>

  <div class="sm-nav-bar__content">
    <nav *ngIf="stateReady" class="sm-nav-bar__menu" [attr.aria-label]="'shell.nav.mainMenuAriaLabel' | translate">
      @for (item of items; track trackById($index, item)) {
        <section class="sm-nav-bar__section">
          <sm-nav-menu-item
            [item]="item"
            [level]="1"
            [selected]="isSelected(item)"
            [expanded]="isExpanded(item.id)"
            [ariaCurrent]="isCurrent(item) ? 'page' : null"
            (itemClick)="handleItemClick($event)">
          </sm-nav-menu-item>

          @if (item.children?.length && isExpanded(item.id)) {
            <div class="sm-nav-bar__children" role="group" [attr.aria-label]="item.text">
              @for (child of item.children; track trackById($index, child)) {
                <sm-nav-menu-item
                  [item]="child"
                  [level]="2"
                  [selected]="selectedId === child.id"
                  [ariaCurrent]="selectedId === child.id ? 'page' : null"
                  (itemClick)="handleItemClick($event)">
                </sm-nav-menu-item>
              }
            </div>
          }
        </section>
      }
    </nav>

    <footer class="sm-nav-bar__footer" *ngIf="footerText || footerActionText">
      @if (footerText) {
        <p class="sm-nav-bar__footer-text">{{ footerText }}</p>
      }

      @if (footerActionText) {
        <sm-action-button
          class="sm-nav-bar__footer-action"
          variant="secondary"
          size="md"
          [fullWidth]="true"
          type="button"
          (click)="handleFooterActionClick()">
          {{ footerActionText }}
        </sm-action-button>
      }
    </footer>
  </div>
</aside>
